import App from './app';
import { initializeIcons, loadTheme, createTheme } from 'office-ui-fabric-react/lib';

initializeIcons(/* optional base url */);

const myTheme = createTheme({
  palette: {
    themePrimary: '#ff8800',
    themeLighterAlt: '#fffaf5',
    themeLighter: '#ffecd6',
    themeLight: '#ffdbb3',
    themeTertiary: '#ffb866',
    themeSecondary: '#ff961f',
    themeDarkAlt: '#e67a00',
    themeDark: '#c26700',
    themeDarker: '#8f4c00',
    neutralLighterAlt: '#0b0b0b',
    neutralLighter: '#151515',
    neutralLight: '#252525',
    neutralQuaternaryAlt: '#2f2f2f',
    neutralQuaternary: '#373737',
    neutralTertiaryAlt: '#595959',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#ffffff',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#000000',
  }});

loadTheme(myTheme);

export { App }

export default App 